window.addEventListener('load', (event) =>{
    let top_lists = document.getElementsByClassName("listgx");
    for(let k = 0 ; k < top_lists.length ; k++ ){
        let top_links = top_lists[k].getElementsByTagName("a");
        for(let j = 0 ; j < top_links.length ; j++){
            top_links[j].onclick = function(e){
                let left_menu = document.getElementsByClassName("tabs-widget");
                for(let m = 0 ; m < left_menu.length ; m++){
                     let left_links = left_menu[m].getElementsByTagName("a");
                     for(let n = 0 ; n < left_links.length;n++){
                        if(e.target.innerText == left_links[n].innerText){
                            if(screen.width<990){
                                left_links[n].parentElement.parentElement.parentElement.scrollIntoView({
                                   behavior:"smooth",
                                   block:"end",
                                   inline: "nearest"
                                 });
                               }else{
                                left_links[n].parentElement.parentElement.parentElement.parentElement.parentElement.scrollIntoView();
                               }
                            left_links[n].click();
                        }
                     }
                }
            }
        }
    }
});
